import * as React from 'react'
import { connect } from 'react-redux'

import { Select } from '@doordash/component-fields'
import styled from 'styled-components'
import * as events from '../../../events'

import t from './strings'

type Props = {
  onChange?: (number) => void
  vehicleTypes: object[]
  label: string
  description: string
  touched: boolean
  error: string
  trackVehicleTypeSelected?: (string) => Promise<any>
}

type State = {
  selectedVehicleType: string | number
}

export const VehicleSelect = styled(Select)`
  box-shadow: ${(props: Props) =>
    props.error ? `inset 0 0 0 1px #ff3008` : `inset 0 0 0 1px #CCCCCC`};
`
VehicleSelect.displayName = 'VehicleSelect'

export class VehicleTypeDropdown extends React.Component<Props, State> {
  public static defaultProps = {
    trackVehicleTypeSelected: console.log,
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedVehicleType: '',
    }
  }

  public render() {
    const { vehicleTypes, label, description, error } = this.props
    const { selectedVehicleType } = this.state

    return (
      <VehicleSelect
        error={error}
        label={label}
        value={selectedVehicleType.toString()}
        onChange={this.handleVehicleTypeChange}
        disabledValue={t.disabledValue()}
        description={description}
        options={this.renderVehicleTypeOptions(vehicleTypes)}
      />
    )
  }
  public handleVehicleTypeChange = value => {
    const { vehicleTypes, trackVehicleTypeSelected }: any = this.props
    const selectedID = parseInt(value, 10)

    // Track selected vehicle type by name
    const selectedVehicle = vehicleTypes.filter(
      key => parseInt(key.value, 10) === selectedID
    )[0]
    trackVehicleTypeSelected(selectedVehicle.name)

    // fields.vehicleType.onChange(value)
    this.setState({ selectedVehicleType: selectedID })
    this.props.onChange(selectedID)
  }

  /*
    Exists to manually exclude "rent a scooter" case (id=6). This can be safely
    removed once the backend no longer expects renting a scooter to be 
    an option.
  */
  public renderVehicleTypeOptions(vehicleTypes: any = {}) {
    return vehicleTypes.filter(key => parseInt(key.value, 10) !== 6)
  }
}

const mapDispatchToProps = {
  trackVehicleTypeSelected: events.trackVehicleTypeSelected,
}

export default connect(
  null,
  mapDispatchToProps
)(VehicleTypeDropdown)
